import { SfxContext } from "@/providers/SfxProvider";
import { useContext } from "react";

export const useSfxProvider = () => {
    return useContext(SfxContext);
}